define('views/modules/calendar/animated-session/session/session-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // events
    'services/events/calendar-events',
    'services/i18n',
    // Parent view
    'src/views/form-view',
    // parts views
    'views/parts/menu/menu-save-action',
    'views/parts/alert/alert-list',
    // views
    'views/modules/calendar/animated-session/session/form/session-form',
    'views/modules/calendar/animated-session/exercise/lists/exercise-list',
    'views/modules/calendar/animated-session/animation/animation-panel',
    'views/modules/calendar/favorite/favorite-modal',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/session/session-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // events
    CalendarEvents,
    i18n,
    // Parent view
    VForm,
    // parts views
    VMenuSaveAction,
    VAlertList,
    // views
    VSessionForm,
    VExerciseList,
    VAnimationPanel,
    VFavoriteModal,
    // Template
    TSessionEditContent
) {

    var VSessionEditContent = VForm.extend({
        template: TSessionEditContent,
        exerciseListView: VExerciseList,

        // abstracting selectors out of the view logic
        regions: {
            root: "#sessionedit-content",
            menu: ".menu-actions",
            form: "#session-details-form",
            list: "#session-edit",
            alert: "#session-alert",
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                group: opt.group,
                role: opt.role
            });

            var menuCollection = new Backbone.Collection([{
                title: i18n.t('calendar:Add exercises'),
                itemClass: 'big-action',
                content: '<strong>+</strong>',
                skipTranslation: 'true',
                callback: this.onAddExerciseAction
            }]);

            if (this.role === 'supervisor') {
                menuCollection.add({ title: i18n.t('calendar:Add current session to my favorites'), icon: 'sl-icon-star', callback: this.onAddToFavoriteAction });
            }

            var model = this.model,
                collection = this.collection = model.getExerciseCollection(),
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveClick,
                        saveText: 'Save',
                        radio: false,
                        collection: menuCollection,
                        tooltip: {
                            container: this.regions.root,
                        }
                    }),
                    form: new VSessionForm({ model: model }),
                    list: new this.exerciseListView({
                        model: model,
                        role: this.role,
                        group: this.group,
                        collection: collection,
                        hideBottomMenu: false,
                    }),
                };

            this.collectionCopy = collection.toJSON({ blacklist: true });

            this.listenTo(collection, {
                'list:addExercise': this.onAddExerciseAction,
                'change update': this.onCollectionChange,
                'change:sets': this.onModelChange
            });

            this.listenTo(model, {
                'change:exercises': this.onExercisesChange,
                'change': this.onModelChange,
                'favorite:create': this.onFavoriteCreate,
                'favorite:applied': this.onFavoriteApplied
            });
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext());
            this.$el.empty().append(html);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu, { defer: true })
                .assign(view.form, zone.$form, { defer: true })
                .assign(view.list, zone.$list, { defer: true })
                .renderAlertView();

            return this;
        },

        toggleAnimationPanel: function(val) {
            // lazy instanciation
            var view = this.view,
                animation = view.animation || (view.animation = new VAnimationPanel({ group: this.group }));

            animation.render();
            this.trigger('drawer:view', animation, val);
            return this;
        },

        isDirty: function() {
            return VSessionEditContent.__super__.isDirty.apply(this, arguments) ||
                this.hasCollectionChanged();
        },

        renderAlertView: function() {
            var alert = this.view.alert;
            if (alert) this.assign(alert, this.zone.$alert);
            return this;
        },

        setExercises: function() {
            var collection = this.collection;
            if (this.hasCollectionChanged()) {
                collection.setLoadUnit();
                this.model.setExercises(collection.toJSON({ blacklist: true }));
            }
        },

        hasCollectionChanged: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddExerciseAction: function(e, actionModel) {
            this.toggleAnimationPanel(true);
        },

        onAddToFavoriteAction: function(e, actionModel) {
            var view = this.view.favorite;

            if (!view) {
                view = this.view.favorite = new VFavoriteModal({
                    type: 'animated-session',
                    item: this.model
                });
                this.listenTo(view, 'form:success', this.onFavoriteSuccess);
            }

            view.resetModel().render();
        },

        onSaveClick: function() {
            this.submit();
        },

        ////////////
        // events //
        ////////////

        onExercisesChange: function(model, value, options) {
            this.model.resetExerciseCollection();
            this.collectionCopy = this.collection.toJSON({ blacklist: true });
        },

        onSubmit: function() {
            this.setExercises();
        },

        onValidate: function() {
            var result = this.collection.isValid();
            if (!result) {
                this.collection.each(function(model) {
                    U.warn(model.validationError);
                });
            }
            return result;
        },

        onSuccess: function() {
            CalendarEvents.sessionUpdate(this.model.clone());
        },

        // onUnchanged: function() {
        // },
        onInvalid: function() {
            var view = this.view,
                alert = view.alert;
            if (!alert) {
                alert = view.alert = new VAlertList();
                this.renderAlertView();
                delete this.view.alert;
            }

            alert.reset();

            _.each(this.model.validationError, function(errors) {
                alert.addError(i18n.t('general:' + errors));
            }, this);
        },

        onCollectionChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onModelChange: function(model, options) {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onFavoriteSuccess: function(model) {
            this.trigger('favorite:success', model);
        },

        onFavoriteCreate: function() {
            this.model.trigger('favorite:set:collection', 'exercises', this.collection.toJSON({ blacklist: true }));
        },

        onFavoriteApplied: function() {
            this.view.list.options.resetCollection = false;
            this.collection.reset(this.model.getExerciseCollection().models);
        },

    });

    return VSessionEditContent;
});

